<template>
  <div id="booking-form">
    <main class="">
    <section class="bg-primary h-50vh md:h-70vh w-full pt-4 relative pb-8 main-hero  bg-cover bg-center bg-no-repeat pt-6 md:pt-12 pb-8 md:pb-20" :style="imgBack">


       <div class="max-w-screen-2xl mx-auto px-4 flex relative flex-col flex-wrap justify-between h-full ">
          <div class=" w-full">
            <LogoHeader />
          </div>
          <div class="w-full ">
            <h1 class="md:w-6/12 text-white font-secondary leading-tight text-4xl md:text-5-6xl font-normal md:pr-16 mb-3 text-left">{{tr("Booking Form")}}</h1>
            <p class="text-white font-light text-lg md:text-1/3xl" v-html="paxName"></p>
          </div>

       </div>
    </section>
    <section class="py-8 md:py-12" v-if="ready && !isClosed">
      <form class="w-full" action=""  ref="myForm">
        <div v-if="!sharedContactHidden" class="max-w-screen-2xl mx-auto px-4 flex relative flex-wrap w-full py-8 border-b-2 border-[#4C535966]">
          <div class="w-full">
            <h2 class="font-secondary text-2xl md:text-3xl mb-8">
            {{tr("Contact")}}
            </h2>
          </div>
          <div class="w-full grid md:grid-cols-4 sm:grid-cols-2 grid-cols-1 gap-4 items-end">
            <div class="mb-5">
              <label  class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Reservation Name")}}<span class="ml-2 text-primary">*</span></label>
              <input type="text" :class="{'error': contactErrors.name}" v-model="contact.name" :disabled="contactInformationDisabled" :readonly="contactInformationDisabled"
                class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent  outline-none block w-full p-3 " />
            </div>

            <div class="mb-5">
              <label  class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Address")}}<span class="ml-2 text-primary">*</span></label>
              <input type="text" :class="{'error': contactErrors.address}" v-model="contact.address" :disabled="contactInformationDisabled" :readonly="contactInformationDisabled"
                class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3 "  />
            </div>

            <div class="mb-5">
              <label class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("ZIP CODE")}}<span class="ml-2 text-primary">*</span></label>
              <input type="text" :class="{'error': contactErrors.zipcode}" v-model="contact.zipcode" :disabled="contactInformationDisabled" :readonly="contactInformationDisabled"
                class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3 " />
            </div>

             <div class="mb-5">
              <label class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Nationality")}}<span class="ml-2 text-primary">*</span></label>
              <select id="countries" :class="{'error': contactErrors.nationality}"  v-model="contact.nationality" :disabled="contactInformationDisabled"
                class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3">
                <option v-for="(c, i) of countriesJSON" :key="i" :value="c.alpha2" :selected="c.alpha2 == contact.nationality"> {{ c.name }}</option>
              </select>
            </div>

            <div class="mb-5">
              <label  class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Cellphone")}}</label>
              <input type="text" :class="{'error': contactErrors.mobile}" v-model="contact.mobile" :disabled="contactInformationDisabled" :readonly="contactInformationDisabled"
                class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent  outline-none block w-full p-3 " />
            </div>

            <div class="mb-5">
              <label  class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Email")}}<span class="ml-2 text-primary">*</span></label>
              <input type="email" :class="{'error': contactErrors.email}" v-model="contact.email" :disabled="contactInformationDisabled" :readonly="contactInformationDisabled"
                class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3 "  />
            </div>

            <div class="mb-5 sm:col-span-2">
              <p class="text-primary text-sm">{{tr("Y_WILL_")}}</p>

            </div>
          </div>


        </div>

        <div v-if="!sharedContactHidden" class="max-w-screen-2xl mx-auto px-4 flex relative flex-wrap w-full py-8 border-b-2 border-[#4C535966] mt-2 md:mt-4">
          <div class="w-full">
            <h2 class="font-secondary text-2xl md:text-3xl mb-8">
            {{tr("Emergency Contact")}}
            </h2>
          </div>
          <div class="w-full grid md:grid-cols-4 sm:grid-cols-2 grid-cols-1 gap-4 items-end">
            <div class="mb-5">
              <label class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Full name")}}<span class="ml-2 text-primary">*</span></label>
              <input type="text" :class="{'error': emergencyContactErrors.fullName}" v-model="emergencyContact.fullName" :disabled="contactInformationDisabled" :readonly="contactInformationDisabled"
                class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3 " />
            </div>

            <div class="mb-5">
              <label class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Relationship")}}<span class="ml-2 text-primary">*</span></label>
              <input type="text" :class="{'error': emergencyContactErrors.relationship}" v-model="emergencyContact.relationship" :disabled="contactInformationDisabled" :readonly="contactInformationDisabled"
                class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3 " />
            </div>

            <div class="mb-5">
              <label class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Main telephone number with country/area code")}}<span class="ml-2 text-primary">*</span></label>
              <input type="text" :class="{'error': emergencyContactErrors.primaryPhone}" v-model="emergencyContact.primaryPhone" :disabled="contactInformationDisabled" :readonly="contactInformationDisabled"
                class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3 " />
            </div>

            <div class="mb-5">
              <label class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Secondary phone")}}</label>
              <input type="text" :class="{'error': emergencyContactErrors.secondaryPhone}" v-model="emergencyContact.secondaryPhone" :disabled="contactInformationDisabled" :readonly="contactInformationDisabled"
                class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3 " />
            </div>

            <div class="mb-5">
              <label class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Email address")}}<span class="ml-2 text-primary">*</span></label>
              <input type="email" :class="{'error': emergencyContactErrors.email}" v-model="emergencyContact.email" :disabled="contactInformationDisabled" :readonly="contactInformationDisabled"
                class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3 " />
            </div>
          </div>
        </div>

        <div class="max-w-screen-2xl mx-auto px-4 flex relative flex-wrap w-full py-8 border-b-2 border-[#4C535966] mt-2 md:mt-4">
          <div class="w-full">
            <h2 class="font-secondary text-2xl md:text-3xl mb-8">
            {{tr("Travelers")}}
            </h2>
          </div>
          <div v-for="(pax, j) of passengers" :key="'pax-' + j" class="mb-8">
            <BookingFormPax 
              :passenger="passengers[j]" 
              @updateData="updatePax" 
              :errors="paxErrors[j]" 
              :paxNumber="j"
              :isDisabled="passengers[j].isExistingRecord"
              :paxList="passengersList"
              :isFirstPassenger="j === 0"
              :firstEmergencyContact="firstPassengerEmergencyContact"
              :isGroup="isGroup"
            >
            </BookingFormPax>
            <div class="w-full text-right trash mt-3" @click="passengers.splice(j, 1)" v-if="j>0 && !passengers[j].isExistingRecord">
              X
            </div>
          </div>
          <div class="mb-5 sm:col-span-4 mt-5">
            <button
              class="py-2 px-4 border cursor-pointer border-orange-500 rounded-md text-base font-bold bg-orange-500 text-white hover:bg-orange-600 transition-all"
              @click.prevent="addPax"
            >
              + {{tr("Add Traveler")}}
            </button>
          </div>

        </div>

        <div v-if="!isGroup" class="max-w-screen-2xl mx-auto px-4 flex relative flex-wrap w-full py-8 border-b-2 border-[#4C535966] mt-2 md:mt-4">
          <div class="w-full">
            <h2 class="font-secondary text-2xl md:text-3xl mb-8">
            {{tr("International Flights")}} <span class="font-light font-primary text-1/2xl md:text-2xl">({{tr("Booked on your own")}})</span>
            </h2>
          </div>
          <div v-for="(f, j) of internationalFlights" :key="'flightI-' + j" class="w-full mb-8">
            <BookingFormFlight :flight="internationalFlights[j]" @update="updateFlightInternational($event, j)"></BookingFormFlight>
            <div class="w-full text-right trash mt-3" @click="internationalFlights.splice(j, 1)" v-if="j>0">
              X
            </div>
          </div>

          <div class="mb-5 sm:col-span-2 mt-5">
            <button class="py-2 px-4 border cursor-pointer border-primary rounded-md text-sm text-primary hover:bg-primary hover:text-white" @click.prevent="addFlightInternational">+ {{tr("Add Flight")}}</button>
          </div>
        </div>

        <div v-if="!isGroup" class="max-w-screen-2xl mx-auto px-4 flex relative flex-wrap w-full py-8 border-b-2 border-[#4C535966] mt-2 md:mt-4">
          <div class="w-full">
            <h2 class="font-secondary text-2xl md:text-3xl mb-8">
            {{tr("Domestic Flights")}} <span class="font-light font-primary text-1/2xl md:text-2xl">({{tr("Booked on your own")}})</span>
            </h2>
          </div>
          <div v-for="(f, j) of domesticFlights" :key="'flightD-' + j" class="w-full mb-8">
            <BookingFormFlight :flight="domesticFlights[j]" @update="updateFlightDomestict($event, j)"></BookingFormFlight>
            <div class="w-full text-right trash mt-3" @click="domesticFlights.splice(j, 1)" v-if="j>0">
              X
            </div>
          </div>

          <div class="mb-5 sm:col-span-2 mt-5">
            <button class="py-2 px-4 border cursor-pointer border-primary rounded-md text-sm text-primary hover:bg-primary hover:text-white" @click.prevent="addFlightDomestict">+ {{tr("Add Flight")}}</button>
          </div>
        </div>

        <div v-if="!isGroup" class="max-w-screen-2xl mx-auto px-4 flex relative flex-wrap w-full py-8 border-b-2 border-[#4C535966]">
          <div class="w-full">
            <h2 class="font-secondary text-2xl md:text-3xl mb-8">
            {{tr("Rooms Information")}}
            </h2>
          </div>
          <div v-for="(f, j) of rooms" :key="'room-' + j" class="w-full">
            <BookingFormRoom :room="rooms[j]" @update="updateRoom($event, j)"></BookingFormRoom>
          </div>

          <div class="mb-5 sm:col-span-3 mt-5">
            <button class="py-2 px-4 border cursor-pointer border-primary rounded-md text-sm text-primary hover:bg-primary hover:text-white" @click.prevent="addRoom">+ {{tr("Add Room")}}</button>
          </div>
        </div>
        
        <div class="max-w-screen-2xl mx-auto px-4 flex relative flex-wrap w-full py-8 border-b-2 border-[#4C535966]">
          <div class="w-full mb-2">
            *{{tr("suggested_hotels_text")}}
          </div>
          <div class="w-full flex flex-row">
            <div class="basis-2/3">
              <textarea v-model="SuggestedHotels" :disabled="hotelPreferencesDisabled" :readonly="hotelPreferencesDisabled" rows="4" class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block p-3 w-full"></textarea>
            </div>
            <div class="basis-1/3 flex justify-center items-center">
              <a
                v-if="lang != 'DE'"
                class="justify-self-center font-light border border-dark bg-white text-md py-2 px-4 hover:bg-primary hover:text-dark transition-all hover:border-primary rounded-lg text-center cursor-pointer"
                @click="viewHotels"
                >{{ tr("View") }} <template v-if="!hidePrices">{{ category }}</template> {{ tr("Hotels") }}
              </a>
              <a
                v-else
                class="justify-self-center font-light border border-dark bg-white text-md py-2 px-4 hover:bg-primary hover:text-dark transition-all hover:border-primary rounded-lg text-center cursor-pointer"
                @click="viewHotels"
                > <template v-if="!hidePrices">{{ category }}</template> Hotels sehen</a
              >
            </div>
          </div>
        </div>

        <div class="max-w-screen-2xl mx-auto px-4 flex relative flex-wrap w-full py-8 mt-2 md:mt-4">
          <div class="w-full">

           <div class="flex flex-wrap w-full md:w-1/3 mx-auto items-center justify-center font-normal text-md">
              
              <label v-if="!isGroup" for="link-checkbox" class="ms-2 ">
                <input v-model="accept" id="link-checkbox" type="checkbox" value="" class="w-4 h-4 text-black mr-2">
                  {{tr("I have read and accept the")}}
                  <p class="underline font-bold uppercase" v-if="custom == 'YOU'">{{tr("terms and conditions")}}</p>
                  <a v-else href="https://sayhueque.com/terms-conditions/" target="_blank" class="underline font-bold uppercase">{{tr("terms and conditions")}}</a>.
              </label>

              <button :class="{'disabled': !isGroup && !accept}" @click.prevent="send" :disabled="(!isGroup && !accept) || sending"
                class="bg-primary py-2 px-4 w-full hover:bg-dark transition-all rounded-md mt-8 text-white font-semibold text-lg">{{tr("Send")}}</button>
              <div class="text-green-500" v-if="succesMessage">{{ tr("_FormText") }}</div>
              <div class="text-red-500" v-if="dangerMessage">{{ dangerMessage }}</div>
            </div>
            <br>
            <p v-if="dangerMessage">*{{ tr('_warning_error_booking_form') }}</p>
            <p>*{{ tr('Please note that the information you provide cannot be modified online. If you enter any incorrect details, you must contact your travel agent to request changes') }}</p>
        
          </div>
        </div>


      </form>
    </section>
    <ClosedText v-else-if="ready && isClosed" />



  </main>

    <Footer></Footer>
    <Transition>
        <BlockUI v-if="loading"></BlockUI>
    </Transition>
  </div>
</template>

<script>
import * as _ from 'lodash';

import BlockUI from '@/components/tools/BlockUI.vue';
import Footer from '@/components/tools/Footer.vue';
import BookingFormPax from '@/components/bookingform/BookingFormPax.vue';
import BookingFormFlight from '@/components/bookingform/BookingFormFlight.vue';
import BookingFormRoom from '@/components/bookingform/BookingFormRoom.vue';
import LogoHeader from '@/components/tools/LogoHeader.vue';
import ClosedText from '@/components/itinerary/ClosedText.vue';
import fondoForm from '@/assets/img/fondoform.png';
import '@/assets/css/main.scss';
let countriesJSON = require(`@/assets/world.json`);
const api = window.api;

export default {
  name: 'BookingFrom',
  data() {
    return {
      loading: false,
      accept: false,
      sending: false,
      imgBack: null,
      ready: false,
      SuggestedHotels: '',
      countriesJSON: countriesJSON,
      contact: {
        nationality: '',
        zipcode: '',
        email: '',
        address: '',
        name: '',
        mobile: ''
      },
      emergencyContact: {
        fullName: '',
        relationship: '',
        primaryPhone: '',
        secondaryPhone: '',
        email: ''
      },
      contactInformationLocked: false,
      persistedContactInformation: false,
      persistedHotelPreferences: false,
      passengers: [],
      internationalFlights: [],
      domesticFlights: [],
      rooms: [],
      trySend: false,
      pax: {
        selected: '',
        name: '',
        middleName: '',
        lastName: '',
        DOB: '',
        gender: '',
        nationality: '',
        passport: '',
        passportExpirationDate: '',
        address: '',
        email: '',
        mobile: '',
        emergencyContact: '',
        tripReason: '',
        allergies: '',
        medicalConditions: '',
        medication: '',
        medicalConditionsMedications: '',
        foodRestriction: '',
        sharingRoomWith: '',
        typeOfBedding: '',
        hobbies: '',
        arrivalFlight: '',
        departureFlight: '',
        insuranceCompany: '',
        insurancePolicyNumber: '',
        insuranceEmergencyPhone: '',
        files: [],
        isExistingRecord: false,
        paxId: null,
        internationalFlights: [],
        domesticFlights: []
      },
      flight: {
        airline: '',
        number: '',
        reservationCode: '',
        departureDate: '',
        arrivalDate: '',
        departureCity: '',
        arrivalCity: '',
        departureTime: '',
        arrivalTime: ''
      },
      room: {
        type: '',
        names: '',
      },
      contactRequired: ['name', 'address', 'email', 'nationality', 'zipcode'],
      emergencyContactRequired: ['fullName', 'relationship', 'primaryPhone', 'email'],
      passangersCount: 0,
      completedPassengerSelections: [],
      paxErrors: {},
      contactErrors: {
        nationality: '',
        zipcode: '',
        email: '',
        address: '',
        name: '',
        mobile: '',
      },
      emergencyContactErrors: {
        fullName: '',
        relationship: '',
        primaryPhone: '',
        secondaryPhone: '',
        email: '',
      },
      isNewRecord: true,
      user_code: '',
      succesMessage: false,
      dangerMessage: false,
      duplicatedNewPassengerIndexes: [],
      firstInvalidField: null,
    }
  },
  props: {
  },
  computed: {
    coverImg () {
      return this.$store.state.coverImg;
    },
    tripName () {
      return this.$store.state.tripName;
    },
    paxName () {
      const booking = this.$store.state.fitBooking?.[0] || {};
      const name = this.$store.state.paxName || booking.BookingNameAlias || booking.BookingName || this.$route.query.Code || '';
      return `${this.tr('For')} ${name}`;
    },
    custom () {
      return this.$store.state.custom;
    },
    agent () {
      return this.$store.state.agent;
    },
    passengersList() {
      if (this.isGroupsSource) {
        let allNumbers = Array.from({length: this.passangersCount}, (_, i) => String(i + 1));
        let selectedPassengers = this.completedPassengerSelections.concat(
          this.passengers.filter(p => p?.selected).map(p => p?.selected)
        );
        return allNumbers.filter(n => !selectedPassengers.includes(n));
      }
      let passengers = this.$store.state.fitPrices?.map(p => p.PaxName);
      let selectedPassengers = this.completedPassengerSelections.concat(
        this.passengers.filter(p => p?.selected).map(p => p?.selected)
      );
      let passengersList = passengers.filter(p => selectedPassengers.indexOf(p) === -1);
      return passengersList;
    },
    firstPassengerEmergencyContact () {
      return this.passengers?.[0]?.emergencyContact || '';
    },
    referenceCode () {
      return String(this.$route.query.Code || '').trim().toUpperCase();
    },
    isGroupsSource () {
      return this.referenceCode.startsWith('GR');
    },
    isGroup () {
      return this.isGroupsSource || this.passangersCount >= 8;
    },
    contactInformationDisabled () {
      return this.contactInformationLocked || this.persistedContactInformation;
    },
    sharedContactHidden () {
      return this.isGroup && this.contactInformationDisabled;
    },
    hotelPreferencesDisabled () {
      return this.isGroup && this.persistedHotelPreferences;
    },
    paxRequired () {
      if (this.isGroup) {
        return ['selected', 'name', 'middleName', 'lastName', 'nationality', 'DOB', 'passport', 'passportExpirationDate', 'email', 'mobile'];
      }
      return ['selected', 'name', 'lastName', 'nationality', 'DOB', 'passport', 'passportExpirationDate'];
    },
    fitStatus () {
      return this.$store.state.fitStatus;
    },
    isClosed () {
      return this.fitStatus === 'Cerrado' || this.fitStatus === 'Cierre Operativo';
    },
    hotels () {
      return this.$store.state.hotels;
    },
    category () {
      if (this.hotels) {
        let rows = _.uniqBy(this.hotels, (r) => r.ClassCode);
        if (rows.length == 1 && rows[0].ClassName != 'Unassigned') {
          return rows[0].ClassName;
        }
      }
      return '';
    },
    lang () {
      return this.$store.state.lang;
    },
    hidePrices () {
      return this.$store.state.hidePrices
    }
  },
  async mounted() {
    this.ready = false;
    this.loading = true;
    this.imgBack = { backgroundImage: `url(${fondoForm})` };
    let bookingInfo = [];

    try {
      if (!this.referenceCode) {
        throw new Error('Missing booking reference');
      }

      await this.fetchRecord();
      const [clientImage, bookingResult] = await Promise.all([
        api.get('/api/tpsql/fit_client_image', this.$route.query).catch(() => false),
        this.fetchBookingInfo()
      ]);
      bookingInfo = bookingResult || [];
      if (clientImage) this.$store.commit('setClientImage', clientImage);
      this.$store.commit('setAgent', bookingInfo?.[0]?.agent);
      this.$store.commit('setFITBooking', bookingInfo);

      if (this.isClosed) return;

      if (this.isNewRecord){
        this.addPax();
        this.domesticFlights.push(Object.assign({}, this.flight));
        this.internationalFlights.push(Object.assign({}, this.flight));
        this.rooms.push(Object.assign({}, this.room));
      }

      const sellerUrl = this.isGroupsSource
        ? '/api/tpsql/group_seller_db'
        : '/api/tpsql/fit_seller_db';
      const [cover, seller] = await Promise.all([
        api.get('/api/tpsql/trip_cover', this.$route.query).catch(() => false),
        api.get(sellerUrl, this.$route.query)
      ]);
      if (Array.isArray(cover)) {
        this.$store.commit('setNames', { values: cover, isPCM: false });
      }
      if (seller) {
        this.$store.commit('setSeller', seller);
        this.user_code = String(seller.TourPlanUser || '').trim();
      } else if (bookingInfo?.[0]?.agent) {
        this.user_code = String(bookingInfo[0].agent).trim();
      }
    } catch (error) {
      console.error('[BookingForm] Initialization failed', error);
      this.dangerMessage = this.tr('Unable to load booking form. Please try again.');
    } finally {
      this.ready = true;
      this.loading = false;
      this.$store.commit('setQuery', this.$route.query);
    }
  },
  methods: {
    async fetchBookingInfo () {
      const url = this.isGroupsSource ? '/api/groups/group_booking' : '/api/tpsql/fit_booking';
      return await api.get(url, this.$route.query);
    },
    async groupPrices () {
      return await api.get('/api/groups/group_prices', this.$route.query);
    },
    addPax () {
      this.paxErrors[this.passengers.length] = {};
      const newPax = Object.assign({}, this.pax);
      newPax.isExistingRecord = false; // Asegurarse de que nuevos pasajeros no estén marcados como existentes
      newPax.paxId = null;
      newPax.internationalFlights = [];
      newPax.domesticFlights = [];
      this.passengers.push(newPax);
    },
    tr(key) {
      return this.$root.tr(key);
    },
    addFlightInternational () {
      this.internationalFlights.push(Object.assign({}, this.flight))
    },
    addFlightDomestict () {
      this.domesticFlights.push(Object.assign({}, this.flight))
    },
    addRoom () {
      this.rooms.push(Object.assign({}, this.room))
    },
    updatePax (event, paxNumber) {
      this.passengers[paxNumber] = Object.assign({}, event);
      this.check();
    },
    updateFlightDomestict (event, j) {
      this.domesticFlights[j] = Object.assign({}, event);
    },
    updateFlightInternational (event, j) {
      this.internationalFlights[j] = Object.assign({}, event);
    },
    updateRoom (event, j) {
      this.rooms[j] = Object.assign({}, event);
    },
    flightFromRecord (flight, processValue = value => value || '') {
      return {
        airline: processValue(flight.Airline),
        number: processValue(flight.FlightNumber),
        reservationCode: processValue(flight.ReservationCode),
        departureDate: processValue(flight.DepartureDate),
        arrivalDate: processValue(flight.ArrivalDate),
        departureCity: processValue(flight.DepartureCity),
        arrivalCity: processValue(flight.ArrivalCity),
        departureTime: processValue(flight.DepartureTime),
        arrivalTime: processValue(flight.ArrivalTime)
      };
    },
    async send () {
      this.trySend = true;
      this.dangerMessage = false;
      const maxFileSize = 10 * 1000 * 1000;
      const hasOversizedPassport = this.passengers.some(passenger =>
        Array.from(passenger.files || []).some(photo => photo && photo.size > maxFileSize)
      );
      if (hasOversizedPassport) {
        this.dangerMessage = this.tr('SIZE_LIMIT_EXCEEDED');
        return;
      }
      if (!this.check()) {
        const invalidLabel = this.firstInvalidField ? this.tr(this.firstInvalidField.label) : '';
        this.dangerMessage = invalidLabel ? `Complete required field: ${invalidLabel}` : 'Complete fields required';
        this.$nextTick(() => {
          const invalidElement = this.$el.querySelector('.error');
          if (invalidElement && invalidElement.offsetParent !== null) {
            invalidElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            invalidElement.focus({ preventScroll: true });
          }
        });
        return;
      }

      if (this.duplicatedNewPassengerIndexes.length) {
        const duplicateDOBMessage = this.tr('Duplicate passengers detected with the same date of birth. Please review the information to proceed.') + ' ' + this.tr("Do you want to continue anyway?");
        const continueWithDuplicateDOB = confirm(duplicateDOBMessage);
        if (!continueWithDuplicateDOB) {
          this.duplicatedNewPassengerIndexes.forEach((idx) => {
            if (!this.paxErrors[idx]) this.paxErrors[idx] = {};
            this.paxErrors[idx].DOB = true;
          });
          this.paxErrors = Object.assign({}, this.paxErrors);
          this.dangerMessage = this.tr('Duplicate passengers detected with the same date of birth. Please review the information to proceed.');
          return;
        }
      }
      
      const formData = new FormData();
      formData.append('bookingType', this.isGroup ? 'GROUPS' : '');

      if (!this.contactInformationDisabled) {
        for (let key in this.contact) {
          formData.append(`contact[${key}]`, this.contact[key]);
        }
        for (let key in this.emergencyContact) {
          formData.append(`emergencyContact[${key}]`, this.emergencyContact[key]);
        }
      }
      this.passengers.forEach((passenger, pIndex) => {
        for (let key in this.pax) {
          if (['files', 'isExistingRecord', 'paxId', 'internationalFlights', 'domesticFlights'].includes(key)) continue;
          formData.append(`passengers[${pIndex}][${key}]`, passenger[key]);
        }
        const appendPaxFlights = (collection, flightType) => {
          (passenger[collection] || []).forEach((flight, fIndex) => {
            const prefix = `passengers[${pIndex}][${collection}][${fIndex}]`;
            formData.append(`${prefix}[airline]`, flight.airline || '');
            formData.append(`${prefix}[FlightNumber]`, flight.number || '');
            formData.append(`${prefix}[ReservationCode]`, flight.reservationCode || '');
            formData.append(`${prefix}[DepartureDate]`, flight.departureDate || '');
            formData.append(`${prefix}[ArrivalDate]`, flight.arrivalDate || '');
            formData.append(`${prefix}[DepartureCity]`, flight.departureCity || '');
            formData.append(`${prefix}[ArrivalCity]`, flight.arrivalCity || '');
            formData.append(`${prefix}[DepartureTime]`, flight.departureTime || '');
            formData.append(`${prefix}[ArrivalTime]`, flight.arrivalTime || '');
            formData.append(`${prefix}[FlightType]`, flightType);
          });
        };
        if (this.isGroup) {
          appendPaxFlights('internationalFlights', 'INTERNATIONAL');
          appendPaxFlights('domesticFlights', 'DOMESTIC');
        }
        
        if (passenger.isExistingRecord && passenger.paxId) {
          formData.append(`passengers[${pIndex}][id]`, passenger.paxId);
        }
        
        Array.from(passenger.files).forEach((photo, phIndex) => {
          if (photo) {
            formData.append(`passengers[${pIndex}][passportPhotos][${phIndex}]`, photo);
          }
        });
      });

      if (!this.isGroup) this.internationalFlights.forEach((flight, fIndex) => {
        formData.append(`internationalFlights[${fIndex}][airline]`, flight.airline || '');
        formData.append(`internationalFlights[${fIndex}][FlightNumber]`, flight.number || '');
        formData.append(`internationalFlights[${fIndex}][ReservationCode]`, flight.reservationCode || '');
        formData.append(`internationalFlights[${fIndex}][DepartureDate]`, flight.departureDate || '');
        formData.append(`internationalFlights[${fIndex}][ArrivalDate]`, flight.arrivalDate || '');
        formData.append(`internationalFlights[${fIndex}][DepartureCity]`, flight.departureCity || '');
        formData.append(`internationalFlights[${fIndex}][ArrivalCity]`, flight.arrivalCity || '');
        formData.append(`internationalFlights[${fIndex}][DepartureTime]`, flight.departureTime || '');
        formData.append(`internationalFlights[${fIndex}][ArrivalTime]`, flight.arrivalTime || '');
        formData.append(`internationalFlights[${fIndex}][FlightType]`, 'INTERNATIONAL');
      });

      if (!this.isGroup) this.domesticFlights.forEach((flight, fIndex) => {
        formData.append(`domesticFlights[${fIndex}][airline]`, flight.airline || '');
        formData.append(`domesticFlights[${fIndex}][FlightNumber]`, flight.number || '');
        formData.append(`domesticFlights[${fIndex}][ReservationCode]`, flight.reservationCode || '');
        formData.append(`domesticFlights[${fIndex}][DepartureDate]`, flight.departureDate || '');
        formData.append(`domesticFlights[${fIndex}][ArrivalDate]`, flight.arrivalDate || '');
        formData.append(`domesticFlights[${fIndex}][DepartureCity]`, flight.departureCity || '');
        formData.append(`domesticFlights[${fIndex}][ArrivalCity]`, flight.arrivalCity || '');
        formData.append(`domesticFlights[${fIndex}][DepartureTime]`, flight.departureTime || '');
        formData.append(`domesticFlights[${fIndex}][ArrivalTime]`, flight.arrivalTime || '');
        formData.append(`domesticFlights[${fIndex}][FlightType]`, 'DOMESTIC');
      });

      if (!this.hotelPreferencesDisabled) {
        formData.append('SuggestedHotels', this.SuggestedHotels || '');
      }

      if (!this.isGroup) this.rooms.forEach((room, rIndex) => {
        for (let key in this.room) {
          formData.append(`rooms[${rIndex}][${key}]`, room[key]);
        }
      }); 

      let headers = {}
      this.succesMessage = false
      this.dangerMessage = false
      this.sending = true;

      if (!this.user_code) {
        const sellerUrl = this.isGroupsSource
          ? '/api/tpsql/group_seller_db'
          : '/api/tpsql/fit_seller_db';
        const seller = await api.get(sellerUrl, this.$route.query).catch(() => false);
        this.user_code = String(seller?.TourPlanUser || '').trim();
      }

      const userCode = this.user_code || 'NO_SELLER';
      const response = await api.post('/api/tpsql/bookingform/' + this.$route.query.Code + '/' + userCode, formData, headers, (error) => {
        this.dangerMessage = error;
      }); 
      this.sending = false;
      if (response) {
        this.succesMessage = true
        this.dangerMessage = false;
        //this.resetForm();
        await this.fetchRecord();
      }
    },
    check () {
      if (!this.trySend) return true;
      let res = true;
      this.dangerMessage = false;
      this.duplicatedNewPassengerIndexes = [];
      this.firstInvalidField = null;
      const labels = {
        selected: 'Passanger Select',
        name: 'Name',
        middleName: 'Middle Name',
        lastName: 'Last Name',
        DOB: this.isGroup ? 'Date of Birth' : 'Date of birth',
        passport: this.isGroup ? 'Passport' : 'Valid Passport Number',
        passportExpirationDate: 'Passport Expiration Date', nationality: 'Nationality',
        email: 'Email', mobile: 'Cellphone', address: 'Address', zipcode: 'ZIP CODE',
        fullName: 'Full name', relationship: 'Relationship',
        primaryPhone: 'Main telephone number with country/area code',
        secondaryPhone: 'Secondary phone'
      };
      for (let field of (this.contactInformationDisabled ? [] : this.contactRequired)) {
        if (!this.contact[field]) {
          res = false;
          this.contactErrors[field] = true;
          if (!this.firstInvalidField) this.firstInvalidField = { label: labels[field] || field };
        } else {
          this.contactErrors[field] = false;
        }
      }
      for (let field of (this.contactInformationDisabled ? [] : this.emergencyContactRequired)) {
        if (!this.emergencyContact[field]) {
          res = false;
          this.emergencyContactErrors[field] = true;
          if (!this.firstInvalidField) this.firstInvalidField = { label: labels[field] || field };
        } else {
          this.emergencyContactErrors[field] = false;
        }
      }
      for (let i in this.passengers) {
        if (!this.paxErrors[i]) this.paxErrors[i] = {};
        if (this.passengers[i].isExistingRecord) {
          continue;
        }
        for (let field of this.paxRequired) {
          if (!this.passengers[i][field]) {
            res = false;
            this.paxErrors[i][field] = true;
            if (!this.firstInvalidField) this.firstInvalidField = { label: labels[field] || field };
          } else {
            this.paxErrors[i][field] = false;
          }
        }
      }

      const dobMap = {};
      this.passengers.forEach((passenger, index) => {
        const dob = (passenger.DOB || '').trim();
        if (!dob) return;
        if (!dobMap[dob]) dobMap[dob] = [];
        dobMap[dob].push(index);
      });
      Object.values(dobMap).forEach((indexes) => {
        if (indexes.length > 1) {
          const newPassengerIndexes = indexes.filter((idx) => !this.passengers[idx]?.paxId);
          if (!newPassengerIndexes.length) return;
          this.duplicatedNewPassengerIndexes.push(...newPassengerIndexes);
        }
      });

      if (this.duplicatedNewPassengerIndexes.length) {
        this.duplicatedNewPassengerIndexes = [...new Set(this.duplicatedNewPassengerIndexes)];
      }

      this.contactErrors = Object.assign({}, this.contactErrors);
      this.emergencyContactErrors = Object.assign({}, this.emergencyContactErrors);
      this.paxErrors = Object.assign({}, this.paxErrors);
      return res;
    },
    resetForm() {
      this.sending = false;
      this.contact = {
        nationality: '',
        zipcode: '',
        email: '',
        address: '',
        name: '',
        mobile: '',
      };
      this.emergencyContact = {
        fullName: '',
        relationship: '',
        primaryPhone: '',
        secondaryPhone: '',
        email: ''
      };
      this.contactInformationLocked = false;
      this.persistedContactInformation = false;
      this.persistedHotelPreferences = false;
      this.passengers = [];
      this.internationalFlights = [];
      this.domesticFlights = [];
      this.rooms = [];

      this.contactErrors = {
        nationality: '',
        zipcode: '',
        email: '',
        address: '',
        name: '',
        mobile: '',
      };
      this.emergencyContactErrors = {
        fullName: '',
        relationship: '',
        primaryPhone: '',
        secondaryPhone: '',
        email: '',
      };
      this.paxErrors = {};

      this.accept = false;
      this.trySend = false;

      if (this.$refs.myForm) {
        this.$refs.myForm.reset();
      }
    },
    async fetchRecord() {
      let fitPricesResult = [];
      if (this.isGroupsSource) {
        const groupPricesResult = await this.groupPrices();
        this.passangersCount = Array.isArray(groupPricesResult)
          ? groupPricesResult.reduce((total, item) => total + (Number(item.TOTALPAX) || 0), 0)
          : 0;
        this.$store.commit('setFITPrices', []);
      } else {
        fitPricesResult = await api.get('/api/tpsql/fit_prices', this.$route.query);
        this.$store.commit('setFITPrices', Array.isArray(fitPricesResult) ? fitPricesResult : []);
        this.passangersCount = Array.isArray(fitPricesResult) ? fitPricesResult.length : 0;
      }
      if (this.$route.query.Code) {
        this.record = null;
        try {
          this.record = await api.get(`/api/bookingform/byreference/${this.$route.query.Code}`, null);
        } catch (error) {
          if (error !== 'NOT FOUND') throw error;
        }
        
        if (this.record) {
          this.isNewRecord = false;
          this.SuggestedHotels = this.record.SuggestedHotels || '';
          this.persistedHotelPreferences = Boolean(String(this.SuggestedHotels).trim());
          const processValue = (value) => {
            if (value === "None" || value === null) return '';
            return value || '';
          };

          this.contact = {
            name: processValue(this.record.PaxName),
            address: processValue(this.record.Address),
            zipcode: processValue(this.record.ZipCode),
            nationality: processValue(this.record.Nationality),
            mobile: processValue(this.record.Mobile),
            email: processValue(this.record.Email)
          };
          this.emergencyContact = {
            fullName: processValue(this.record.EmergencyContactFullName),
            relationship: processValue(this.record.EmergencyContactRelationship),
            primaryPhone: processValue(this.record.EmergencyContactPrimaryPhone),
            secondaryPhone: processValue(this.record.EmergencyContactSecondaryPhone),
            email: processValue(this.record.EmergencyContactEmail)
          };
          const lockedValue = this.record.ContactInformationLocked;
          this.contactInformationLocked = lockedValue === true || lockedValue === 1 || String(lockedValue).toLowerCase() === 'true' || lockedValue === '1';
          this.persistedContactInformation = Object.values(this.contact).concat(Object.values(this.emergencyContact)).some(value => String(value || '').trim());
          this.passengers = [];
          this.completedPassengerSelections = [];
          if (this.record.BookingFormPaxs && this.record.BookingFormPaxs.length) {
            this.record.BookingFormPaxs.forEach(pax => {
              const selected = processValue(pax.Selected);
              if (selected) this.completedPassengerSelections.push(selected);

              if (!this.isGroup) {
                const passengerFlights = Array.isArray(pax.BookingFormFlights)
                  ? pax.BookingFormFlights
                  : [];
                const mapFlight = (flight) => ({
                  airline: processValue(flight.Airline),
                  number: processValue(flight.FlightNumber),
                  reservationCode: processValue(flight.ReservationCode),
                  departureDate: processValue(flight.DepartureDate),
                  arrivalDate: processValue(flight.ArrivalDate),
                  departureCity: processValue(flight.DepartureCity),
                  arrivalCity: processValue(flight.ArrivalCity),
                  departureTime: processValue(flight.DepartureTime),
                  arrivalTime: processValue(flight.ArrivalTime)
                });

                this.passengers.push({
                  selected,
                  name: processValue(pax.FirstName),
                  middleName: processValue(pax.MiddleName),
                  lastName: processValue(pax.LastName),
                  DOB: processValue(pax.DOB),
                  gender: processValue(pax.Gender),
                  nationality: processValue(pax.Nationality),
                  passport: processValue(pax.Passport),
                  passportExpirationDate: processValue(pax.PassportExpirationDate),
                  address: processValue(pax.Address),
                  email: processValue(pax.Email),
                  mobile: processValue(pax.Mobile),
                  emergencyContact: processValue(pax.EmergencyContact),
                  tripReason: processValue(pax.TripReason),
                  allergies: processValue(pax.Allergies),
                  medicalConditions: processValue(pax.MedicalConditions),
                  medication: processValue(pax.Medication),
                  medicalConditionsMedications: processValue(pax.MedicalConditionsMedications),
                  foodRestriction: processValue(pax.FoodRestriction),
                  sharingRoomWith: processValue(pax.SharingRoomWith),
                  typeOfBedding: processValue(pax.TypeOfBedding),
                  hobbies: processValue(pax.Hobbies),
                  arrivalFlight: processValue(pax.ArrivalFlight),
                  departureFlight: processValue(pax.DepartureFlight),
                  insuranceCompany: processValue(pax.InsuranceCompany),
                  insurancePolicyNumber: processValue(pax.InsurancePolicyNumber),
                  insuranceEmergencyPhone: processValue(pax.InsuranceEmergencyPhone),
                  files: [],
                  isExistingRecord: true,
                  paxId: pax.id || null,
                  internationalFlights: passengerFlights
                    .filter(flight => flight.FlightType === 'INTERNATIONAL')
                    .map(mapFlight),
                  domesticFlights: passengerFlights
                    .filter(flight => flight.FlightType === 'DOMESTIC')
                    .map(mapFlight)
                });
                this.paxErrors[this.passengers.length - 1] = {};
              }
            });
          }

          if (this.isGroup && this.completedPassengerSelections.length < this.passangersCount) {
            this.addPax();
          }

          if (!this.isGroup) {
              const hasPendingPassengers = Array.isArray(fitPricesResult)
              ? fitPricesResult.length > this.passengers.length
              : this.passengers.length === 0;
            if (hasPendingPassengers) {
              this.addPax();
            }
        }

          this.internationalFlights = [];
          this.domesticFlights = [];
          
          if (this.record.BookingFormFlights && this.record.BookingFormFlights.length) {
            
            this.record.BookingFormFlights.forEach(flight => {
              const flightData = {
                airline: processValue(flight.Airline),
                number: processValue(flight.FlightNumber),
                reservationCode: processValue(flight.ReservationCode),
                departureDate: processValue(flight.DepartureDate),
                arrivalDate: processValue(flight.ArrivalDate),
                departureCity: processValue(flight.DepartureCity),
                arrivalCity: processValue(flight.ArrivalCity),
                departureTime: processValue(flight.DepartureTime),
                arrivalTime: processValue(flight.ArrivalTime)
              };
              
              if (flight.FlightType === 'INTERNATIONAL') {
                this.internationalFlights.push(flightData);
              } else if (flight.FlightType === 'DOMESTIC') {
                this.domesticFlights.push(flightData);
              }
            });
          }
          
          if (this.internationalFlights.length === 0) {
            this.internationalFlights.push(Object.assign({}, this.flight));
          }
          
          if (this.domesticFlights.length === 0) {
            this.domesticFlights.push(Object.assign({}, this.flight));
          }
          
          this.rooms = [];
          if (this.record.BookingFormRooms && this.record.BookingFormRooms.length) {
            this.record.BookingFormRooms.forEach(room => {
              this.rooms.push({
                type: processValue(room.Type),
                names: processValue(room.Names)
              });
            });
          } else {
            this.rooms.push(Object.assign({}, this.room));
          }
          
        }
      }
    },
    viewHotels () {
      let params = this.$route.query;
      params.fit = 'true';
      let route = this.$router.resolve({ name: 'Hotels', params: params })
      route.href = route.href + '?' + new URLSearchParams(this.$route.query).toString();
      window.open(route.href, '_blank');
    },
  },
  components: {
    BlockUI,
    Footer,
    BookingFormPax,
    BookingFormFlight,
    BookingFormRoom,  
    LogoHeader,
    ClosedText
  }
}

</script>

<style scoped>
.disabled {
  cursor: not-allowed;
}
.disabled:hover {
  background-color: grey;
}
.error {
  border: 2px solid red;
}


.trash {
  cursor: pointer;
}


</style>
